<template>
  <LazyModulesStaticPageOrganismsContent>
    <slot />
  </LazyModulesStaticPageOrganismsContent>
</template>
